import Image from 'next/image';

import { cn } from '@/utils/cn';

interface BrandLogoProps {
  className?: string;
  variant?: 'dark' | 'light';
  sizes?: string;
}

// Intrinsic dims mirror the source files: logo.png=300x27, logo-alt.png=185x17.
// Sizing lives in CSS via `className` (parent owns layout); neither file
// gets stretched — both render at their natural aspect ratio.
const LOGO_DIMS = {
  dark: { width: 300, height: 27 },
  light: { width: 185, height: 27 },
} as const;

// Default responsive cap: 300px wide at ≥1440px viewport, scaling down below.
// Callers can override by passing their own `className`.
const DEFAULT_LOGO_CLASS =
  'h-auto w-auto min-w-[160px] max-w-[160px] sm:max-w-[200px] md:max-w-[200px] lg:max-w-[220px] [1440px]:max-w-[300px]';

const DEFAULT_SIZES =
  '(min-width: 1440px) 300px, (min-width: 1024px) 280px, (min-width: 768px) 240px, (min-width: 640px) 200px, 160px';

export function BrandLogo({ className, variant = 'dark', sizes }: BrandLogoProps) {
  const isLight = variant === 'light';
  const dims = LOGO_DIMS[variant];

  return (
    <Image
      priority
      src={isLight ? '/images/logo-alt.png' : '/images/logo.png'}
      alt="DC Commercial"
      width={dims.width}
      height={dims.height}
      sizes={sizes ?? DEFAULT_SIZES}
      className={cn(DEFAULT_LOGO_CLASS, className)}
    />
  );
}
